import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ForceChangePassword() {
  const { refreshUser, logout } = useAuth();
  const navigate = useNavigate();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nw !== confirm) return toast.error("New passwords do not match");
    if (nw.length < 8) return toast.error("Use at least 8 characters");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password updated");
      await refreshUser();
      navigate("/admin");
    } catch (err) { toast.error(formatError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  const input = "w-full rounded-lg border border-slate-600 bg-[#0C131F] p-3 text-slate-100 placeholder:text-slate-500 focus:border-[#E8A317] focus:outline-none focus:ring-1 focus:ring-[#E8A317]";

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0C131F] px-4">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-slate-700 bg-[#151F30] p-8 shadow-2xl" data-testid="force-change-password-form">
        <div className="flex flex-col items-center text-center">
          <ShieldCheck className="h-12 w-12 text-[#E8A317]" />
          <h1 className="mt-3 font-heading text-2xl font-extrabold uppercase text-white">Set a New Password</h1>
          <p className="mt-1 text-sm text-slate-400">For security, please change the initial password before continuing.</p>
        </div>
        <div className="mt-6 space-y-4">
          <input required type="password" placeholder="Current password" className={input} value={cur} onChange={(e) => setCur(e.target.value)} data-testid="cp-current" />
          <input required type="password" placeholder="New password (min 8 chars)" className={input} value={nw} onChange={(e) => setNw(e.target.value)} data-testid="cp-new" />
          <input required type="password" placeholder="Confirm new password" className={input} value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="cp-confirm" />
          <button type="submit" disabled={busy} data-testid="cp-submit" className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-[#E8A317] py-3 font-extrabold uppercase text-[#0A1626] hover:bg-[#CC8F12] disabled:opacity-60">
            {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : null} Update Password
          </button>
          <button type="button" onClick={async () => { await logout(); navigate("/admin/login"); }} className="w-full text-center text-xs text-slate-400 hover:text-slate-200">Sign out</button>
        </div>
      </form>
    </div>
  );
}
